import { type FC } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ListTabBar from "../../molecules/ListTabBar";
import { HorizontalSpacer } from "../../atoms/Spacers";
import ClientInvoicesDocumentsPage from "./ClientInvoicesDocumentsPage";
import ClientInvoiceTemplates from "./ClientInvoiceTemplates";
import ClientInvoiceListPage from "./ClientInvoiceListPage";

interface Props {
  clientIdentifier: string;
}

const tabs: Array<{ tabLabelKey?: string; id: any }> = [
  { id: "invoices", tabLabelKey: "Fakturor" },
  { id: "documents", tabLabelKey: "Dokument" },
  { id: "recievedInvoices", tabLabelKey: "Mottagna fakturor" },
  { id: "templates", tabLabelKey: "Mallar" },
  { id: "settings", tabLabelKey: "Inställningar" },
];

const ClientInvoicesPage: FC<Props> = ({ clientIdentifier }) => {
  const { tab } = useParams<{ tab?: string }>();
  const navigate = useNavigate();
  const selectedTabId = tab ?? "documents";

  const handleSelectTab = (tabId: string) => {
    navigate(`/client/${clientIdentifier}/invoicesNew/${tabId}`);
  };

  return (
    <div>
      <HorizontalSpacer spacing={1.5} />
      <ListTabBar
        tabs={tabs}
        selectedId={selectedTabId}
        onSelectTabId={handleSelectTab}
      />
      <HorizontalSpacer spacing={2} />
      {selectedTabId === "documents" && (
        <ClientInvoicesDocumentsPage clientIdentifier={clientIdentifier} />
      )}
      {selectedTabId === "templates" && <ClientInvoiceTemplates />}
      {selectedTabId === "invoices" && (
        <ClientInvoiceListPage clientIdentifier={clientIdentifier} />
      )}
      {selectedTabId === "recievedInvoices" && (
        <ClientInvoiceListPage
          clientIdentifier={clientIdentifier}
          displayAsRecievedInvoices
        />
      )}
    </div>
  );
};

export default ClientInvoicesPage;
